export const ViewName = {
  EMAIL_ACCOUNT_ATTACHEMENT: 'EMAIL_ACCOUNT_ATTACHEMENT',
  SUBSCRIPTION_ACCOUNT_SEARCH: 'SUBSCRIPTION_ACCOUNT_SEARCH',
  EFFECTIVE_VIEW: 'EFFECTIVE_VIEW',
  HOME: 'HOME',
  MOBILE_NO_MATCHED_CONTACT: 'MOBILE_NO_MATCHED_CONTACT',
  VERIF_SUBSCRIPTION_PROCESS: 'VERIF_SUBSCRIPTION_PROCESS',
  CONTACT_GESTIONNAIRE: 'CONTACT_GESTIONNAIRE',
};
